import { createI18n } from 'vue-i18n'
import danishLang from './locales/da_DK'
import englishLang from './locales/en_US'
import germanLang from './locales/de_DE'
import swedishLang from './locales/sv_SE'

// Vue 3 migration Phase 5a: vue-i18n@9 dropped the global `Vue.use(VueI18n)`
// install. The instance is now created via `createI18n` and registered on
// the app via `app.use(i18n)` (see main.js bootstrap). `legacy: true` keeps
// `$t` / `$tc` working unchanged on Options API components — every existing
// caller in `src/` uses that surface.
export default createI18n({
    legacy: true,
    locale: 'da',
    fallbackLocale: 'en',
    messages: {
        da: danishLang,
        en: englishLang,
        de: germanLang,
        sv: swedishLang,
    },
})
